import { render, staticRenderFns } from "./tFooter.vue?vue&type=template&id=786b9b17"
import script from "./tFooter.vue?vue&type=script&lang=js"
export * from "./tFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports